// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    NoteTaskModelResponse,
    NoteTaskModels,
    NoteTypeCategory,
    NoteTypeModels,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class NotesV2Api extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @summary Get list of Tasks within a Program, with optional filters
     * @param start 0-based index of starting position
     * @param pageSize How many records to include at a time
     * @param onlyIncludeIncomplete Whether or not to only include incomplete tasks
     * @param isAssigned Optional filter to only include assigned or unassigned items
     * @param assignedUserId Optional User ID to filter to; will match any (including unassigned) if null or not provided
     * @param accountId Optional Account ID to filter to; will match any if null or not provided
     * @param caseId Optional Case ID; will match any if null or not provided
     * @param partyId Optional Party ID; will match any if null or not provided
     * @param typeId Optional Type ID; will match any if null or not provided
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async getByProgramByProgramId (start?: number, pageSize?: number, onlyIncludeIncomplete?: boolean, isAssigned?: boolean, assignedUserId?: number, accountId?: number, caseId?: number, partyId?: number, typeId?: number, xProgramId?: number): Promise<AxiosResponse<NoteTaskModels>> {
        const _url_ = '/notes/v2/Task';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        if (start !== undefined) {
            _params_['start'] = Serializer.serialize(start, "number");
        }

        if (pageSize !== undefined) {
            _params_['pageSize'] = Serializer.serialize(pageSize, "number");
        }

        if (onlyIncludeIncomplete !== undefined) {
            _params_['onlyIncludeIncomplete'] = Serializer.serialize(onlyIncludeIncomplete, "boolean");
        }

        if (isAssigned !== undefined) {
            _params_['isAssigned'] = Serializer.serialize(isAssigned, "boolean");
        }

        if (assignedUserId !== undefined) {
            _params_['assignedUserId'] = Serializer.serialize(assignedUserId, "number");
        }

        if (accountId !== undefined) {
            _params_['accountId'] = Serializer.serialize(accountId, "number");
        }

        if (caseId !== undefined) {
            _params_['caseId'] = Serializer.serialize(caseId, "number");
        }

        if (partyId !== undefined) {
            _params_['partyId'] = Serializer.serialize(partyId, "number");
        }

        if (typeId !== undefined) {
            _params_['typeId'] = Serializer.serialize(typeId, "number");
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "number");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<NoteTaskModels>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "NoteTaskModels");
        }
        return response;
    }
    /**
     * 
     * @summary Get a list of Note Types by Program
     * @param noteTypeCategory Note Type Category
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async programNoteTypeGetByProgramId (noteTypeCategory: enums.NoteTypeCategory, xProgramId?: number): Promise<AxiosResponse<NoteTypeModels>> {
        const _url_ = '/notes/v2/ProgramNoteType/{noteTypeCategory}'
            .replace('{' + 'noteTypeCategory' + '}', encodeURIComponent(String(noteTypeCategory)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'noteTypeCategory' is not null or undefined
        if (noteTypeCategory === null || noteTypeCategory === undefined) {
            throw new Error('Required parameter noteTypeCategory was null or undefined when calling programNoteTypeGetByProgramId.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "number");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<NoteTypeModels>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "NoteTypeModels");
        }
        return response;
    }
    /**
     * 
     * @summary Get an existing Task by Program and Task identifiers.
     * @param taskId The task identifier.
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async taskGetByProgramId (taskId: number, xProgramId?: number): Promise<AxiosResponse<NoteTaskModelResponse>> {
        const _url_ = '/notes/v2/Task/{taskId}'
            .replace('{' + 'taskId' + '}', encodeURIComponent(String(taskId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'taskId' is not null or undefined
        if (taskId === null || taskId === undefined) {
            throw new Error('Required parameter taskId was null or undefined when calling taskGetByProgramId.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "number");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<NoteTaskModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "NoteTaskModelResponse");
        }
        return response;
    }
}
